function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import lottie from 'lottie-web';
import "./Lottie.scss";
import { flatten } from './utils/ColorLottie';
export default class Lottie extends React.Component {
  constructor(...args) {
    super(...args);
    this.handleClickToPause = () => {
      // The pause() method is for handling pausing by passing a prop isPaused
      // This method is for handling the ability to pause by clicking on the animation
      if (this.anim.isPaused) {
        this.anim.play();
      } else {
        this.anim.pause();
      }
    };
  }
  componentDidMount() {
    const {
      options,
      eventListeners
    } = this.props;
    const {
      loop,
      autoplay,
      animationData,
      rendererSettings,
      segments,
      color
    } = options;
    const animationDataClone = color ? flatten(color, animationData) : animationData;
    this.options = {
      container: this.el,
      renderer: 'svg',
      loop: loop !== false,
      autoplay: autoplay !== false,
      segments: segments !== false,
      animationData: JSON.parse(JSON.stringify(animationDataClone)),
      rendererSettings
    };
    this.options = {
      ...this.options,
      ...options
    };
    this.anim = lottie.loadAnimation(this.options);
    this.registerEvents(eventListeners);
  }
  shouldComponentUpdate(nextProps) {
    /* Recreate the animation handle if the data is changed */
    if (this.options.animationData !== nextProps.options.animationData) {
      this.deRegisterEvents(this.props.eventListeners);
      this.destroy();
      this.options = {
        ...this.options,
        ...nextProps.options
      };
      this.anim = lottie.loadAnimation(this.options);
      this.registerEvents(nextProps.eventListeners);
    }
    return true;
  }
  componentDidUpdate() {
    if (this.props.isStopped) {
      this.stop();
    } else if (this.props.segments) {
      this.playSegments();
    } else {
      this.play();
    }
    this.pause();
    this.setSpeed();
    this.setDirection();
  }
  componentWillUnmount() {
    this.deRegisterEvents(this.props.eventListeners);
    this.destroy();
    if (this.options && this.options.animationData) {
      this.options.animationData = null;
    }
    this.anim = null;
  }
  setSpeed() {
    this.anim.setSpeed(this.props.speed);
  }
  setDirection() {
    this.anim.setDirection(this.props.direction);
  }
  play() {
    this.anim.play();
  }
  playSegments() {
    this.anim.playSegments(this.props.segments);
  }
  stop() {
    this.anim.stop();
  }
  pause() {
    if (this.props.isPaused && !this.anim.isPaused) {
      this.anim.pause();
    } else if (!this.props.isPaused && this.anim.isPaused) {
      this.anim.pause();
    }
  }
  destroy() {
    if (this.anim) this.anim.destroy();
  }
  registerEvents(eventListeners) {
    eventListeners.forEach(eventListener => {
      this.anim.addEventListener(eventListener.eventName, eventListener.callback);
    });
  }
  deRegisterEvents(eventListeners) {
    eventListeners.forEach(eventListener => {
      this.anim.removeEventListener(eventListener.eventName, eventListener.callback);
    });
  }
  render() {
    const {
      ariaRole,
      ariaLabel,
      isClickToPauseDisabled,
      title,
      style,
      nativeEventListeners
    } = this.props;
    let nativeEvent = {};
    if (nativeEventListeners) {
      const keys = Object.keys(nativeEventListeners);
      keys.forEach(k => nativeEvent[k] = nativeEventListeners[k]);
    }
    const onClickHandler = isClickToPauseDisabled ? () => null : this.handleClickToPause;
    return /*#__PURE__*/React.createElement("div", _extends({
      className: "Lottie",
      ref: c => this.el = c,
      style: style,
      onClick: onClickHandler,
      title: title,
      role: ariaRole,
      "aria-label": ariaLabel,
      tabIndex: "0"
    }, nativeEvent));
  }
}
Lottie.propTypes = {
  eventListeners: PropTypes.arrayOf(PropTypes.object),
  nativeEventListeners: PropTypes.object,
  options: PropTypes.object.isRequired,
  isStopped: PropTypes.bool,
  isPaused: PropTypes.bool,
  speed: PropTypes.number,
  segments: PropTypes.arrayOf(PropTypes.number),
  direction: PropTypes.number,
  ariaRole: PropTypes.string,
  ariaLabel: PropTypes.string,
  isClickToPauseDisabled: PropTypes.bool,
  title: PropTypes.string,
  style: PropTypes.object
};
Lottie.defaultProps = {
  eventListeners: [],
  isStopped: false,
  isPaused: false,
  speed: 1,
  ariaRole: 'button',
  ariaLabel: 'animation',
  isClickToPauseDisabled: false,
  title: ''
};